import { useState, useRef, useEffect } from 'react';
import { PiNote } from "react-icons/pi";
import { PiBarcode } from "react-icons/pi";
import { LiaShippingFastSolid } from "react-icons/lia";
import { TbMapPinCog } from "react-icons/tb";
import { useReactToPrint } from "react-to-print";
import ModalHeader from 'src/components/Modal/ModalHeader';
import Modal from 'src/components/Modal';
import ModalBody from 'src/components/Modal/ModalBody';
import ModalFooter from 'src/components/Modal/ModalFooter';
import TwinButton from 'src/components/TwinButton';
import { Tooltip as ReactTooltip } from "react-tooltip";
import Spinner from 'src/components/Spinner';
import moment from 'jalali-moment';
import { getData } from 'src/actions/getData';
import { post } from 'src/services/HttpClient';
import { notify } from 'src/services/Notification/Notification';
import { convertToIranLocalNumber } from 'src/utils/convertToIranLocalNumber';
import ParcelUI from 'src/components/ParcelUI';
import { IoPrintOutline } from "react-icons/io5";
import { numberWithCommas } from 'src/utils/thousandSeprator';
import { GiLibertyWing } from "react-icons/gi";
import { QRCodeCanvas } from 'qrcode.react';
import { put } from 'src/services/HttpClient/HttpClient';




export default function OrderCard({ order, inboundProducts, type }) {

    const parcelRef = useRef(null)
    const reactToPrintParcelFn = useReactToPrint({
        contentRef: parcelRef,
    });

    const [noteData, setNoteData] = useState()
    const [parcelData, setParcelData] = useState()

    const [isEpostModalOpen, setIsEpostModalOpen] = useState(false)
    const [parcelIsLoading, setParcelIsLoading] = useState(false)
    const [alopeykIsLoading, setAlopeykIsLoading] = useState(false)
    const [isPrintModalOpen, setIsPrintModalOpen] = useState(false)
    const [isPickingModalOpen, setIsPickingModalOpen] = useState(false)
    const [isNoteModalOpen, setIsNoteModalOpen] = useState(false)


    // محصولات سلر
    const sellerItems = order?.orderItems?.filter(item => {
        console.log(item);
        
        return item.seller?.email !== "bodoroj"; // محصول سلر
    });
    

    // بررسی اینکه همه محصولات سلر برای این سفارش inbound دارند
    const allSellerItemsHaveInbound = sellerItems && sellerItems.length > 0
        ? sellerItems.every(item => {
            return inboundProducts?.some(inbound =>
                String(inbound.orderId) === String(order.id)
            );
        })
        : true; // وقتی محصول سلری نیست، دکمه نمایش داده شود

    const [boxSize, setBoxSize] = useState([
        {
            id: 1,
            choosen: true,
        },
        {
            id: 2,
            choosen: false,
        },
        {
            id: 3,
            choosen: false,
        }
    ])

    const handleChangeBoxSize = (id) => {
        let temp = boxSize.map(size => {
            if (size.id == id) {
                return {
                    ...size,
                    choosen: true
                }
            } else {
                return {
                    ...size,
                    choosen: false
                }
            }
        })
        setBoxSize(temp);
    }

    const receiptRef = useRef(null);
    const pickingRef = useRef(null);
    const reactToPrintFn = useReactToPrint({
        contentRef: receiptRef,
    });
    const reactToPrintFn2 = useReactToPrint({
        contentRef: pickingRef,
    });

    useEffect(() => {
        if (isPrintModalOpen) {
            reactToPrintFn()
            setIsPrintModalOpen(false)
        }
    }, [isPrintModalOpen])

    useEffect(() => {
        if (isPickingModalOpen) {
            reactToPrintFn2()
            setIsPickingModalOpen(false)
        }
    }, [isPickingModalOpen])

    useEffect(() => {
        if (!isNoteModalOpen) {
            setNoteData(null)
        }
    }, [isNoteModalOpen])

    // State for managing the swipe functionality
    const [isSwiping, setIsSwiping] = useState(false); // Tracks if the user is currently swiping
    const [startX, setStartX] = useState(0); // Stores the initial X coordinate of the touch/mouse
    const [currentX, setCurrentX] = useState(0); // Stores the current X coordinate during swipe
    const [isShipped, setIsShipped] = useState(false); // Tracks if the product has been marked as shipped

    // State for controlling the ball's horizontal position (translateX)
    // 0 means the ball is at the rightmost position (no translation)
    // Negative values mean the ball is translated to the left
    const [ballOffset, setBallOffset] = useState(0);

    // References to DOM elements for measuring width and applying styles
    const swipeTrackRef = useRef(null); // Reference to the main swipeable button container
    const ballRef = useRef(null); // Reference to the draggable "ball" handle

    // Function to handle the start of a swipe/drag action
    const handleSwipeStart = (e) => {
        if (isShipped) return; // If already shipped, prevent further swiping
        setIsSwiping(true);
        // Get the initial X coordinate from either touch event (for mobile) or mouse event (for desktop)
        setStartX(e.touches ? e.touches[0].clientX : e.clientX);
        setCurrentX(e.touches ? e.touches[0].clientX : e.clientX);
    };

    // Function to handle ongoing swipe/drag movement
    const handleSwipeMove = (e) => {
        if (!isSwiping || isShipped) return; // Only proceed if swiping is active and not yet shipped

        // Get the current X coordinate of the touch/mouse
        const newCurrentX = e.touches ? e.touches[0].clientX : e.clientX;
        setCurrentX(newCurrentX);

        // Get the width of the swipe track and the ball
        const swipeTrackWidth = swipeTrackRef.current ? swipeTrackRef.current.offsetWidth : 0;
        const ballWidth = ballRef.current ? ballRef.current.offsetWidth : 0;

        // Calculate the distance dragged to the left (positive value)
        let dragDistance = startX - newCurrentX;

        // Clamp the dragDistance to be within the draggable track bounds
        // It should not go below 0 (cannot drag right)
        // It should not exceed the maximum possible drag distance (track width minus ball width)
        const maxDragDistance = swipeTrackWidth - ballWidth;
        dragDistance = Math.max(0, Math.min(dragDistance, maxDragDistance));

        // Update the ball's offset (translateX) based on the drag distance
        // Negative value moves the ball to the left
        setBallOffset(-dragDistance);
    };

    // Function to handle the end of a swipe/drag action
    const handleSwipeEnd = async () => {
        if (!isSwiping || isShipped) return; // Only proceed if swiping was active and not yet shipped

        setIsSwiping(false); // End the swiping state
        const swipeTrackWidth = swipeTrackRef.current ? swipeTrackRef.current.offsetWidth : 0;
        const ballWidth = ballRef.current ? ballRef.current.offsetWidth : 0;
        const dragDistance = startX - currentX; // Calculate total drag distance from start to end

        // Define the threshold for a successful swipe (e.g., 70% of the draggable track)
        const maxDragDistance = swipeTrackWidth - ballWidth;
        const swipeThreshold = maxDragDistance * 0.7;

        // Check if the drag distance exceeded the threshold
        if (dragDistance >= swipeThreshold) {
            setIsShipped(true); // Mark as shipped
            // UPDATE ORDER STATUS
            let result = await put(`/orders/${order?.id}/status`, {
                status: "pws-packaged"
            })
            if (result.statusCode == 200) {
                notify("وضعیت سفارش با موفقیت تغییر یافت")
            } else {
                setIsShipped(false)
                notify("خطایی رخ داده است", "error")
            }

            // Snap the ball to the far left by setting its offset to cover the entire draggable range
            setBallOffset(-(swipeTrackWidth - ballWidth));
        } else {
            setBallOffset(0); // Snap the ball back to the right (initial position)
        }
        // Reset start and current X coordinates for the next swipe
        setStartX(0);
        setCurrentX(0);
    };

    const handleEpostParcel = async () => {
        let parcelData = await getData(setParcelData, `epost/parcel/${order.id}`)

        if (parcelData?.body) {
            setIsEpostModalOpen(true);
            return
        }

        setParcelIsLoading(true)
        let result = await post("/epost/parcel/submit", {
            "orderData": {
                ...order,
                email: order.email || `${order.phoneNumber}@gmail.com`,
                packageSize: boxSize.filter(size => size.choosen)[0].id || 1
            }
        })
        notify(result.message, result.success == true ? "success" : "error")
        setParcelIsLoading(false)
        if (result.success) {
            setParcelData(result.body);
            post(`/sendSMS/${convertToIranLocalNumber(order.customer.phone)}/332507`, {
                args: [order.fullName, result?.body?.ParcelCode]
            })
        }
    }

    const getPickupDateAndType = () => {
        const now = new Date();
        const hour = now.getHours();

        if (hour < 12) {
            // امروز
            return {
                date: now.toISOString().split("T")[0],
                type: "same"
            };
        } else {
            // فردا
            const tomorrow = new Date(now);
            tomorrow.setDate(now.getDate() + 1);
            return {
                date: tomorrow.toISOString().split("T")[0],
                type: "same"
            };
        }
    };

    const handleSubmitAlopeyk = async () => {
        const { date, type } = getPickupDateAndType();
        setAlopeykIsLoading(true)
        let result = await post("/alopeyk/parcel", {
            "drop": {
                "address": {
                    "address": `${order?.province}، ${order?.city}، ${order.address}`,
                    "person_name": order.receiverName,
                    "person_phone": convertToIranLocalNumber(order?.receiverPhone),
                    "postal_code": order?.postalCode ?? "1111111111"
                }
            },
            "parcel": {
                "size": boxSize.filter(size => size.choosen)[0].id || 1,
                "worth": 1000000,
                "weight": 100
            },
            "pickup": {
                "date": date,
                "date_type": type,
                "address": {
                    "address": "ب آیت الله اشرفی اصفهانی شمال، پونک، خ. رمضانی، پلاک 26، واحد7",
                    "person_name": "فروشگاه اینترنتی بدورژ",
                    "person_phone": "02191007279",
                    "postal_code": "1111111111"
                }
            }
        })

        setAlopeykIsLoading(false)
        if (result.statusCode == 201) {
            const url = result?.data?.data?.url_barcode;
            if (url) {
                window.open(url, "_blank");
            }
        } else {
            notify(result.message, "error")
        }

    }


    return (
        <>
            <div className={`w-full p-1 rounded-xl border border-gray-200 mx-auto select-none ${order?.orderItems?.filter(item => {
                return item.value !== "bodoroj"; // محصول سلر
            })?.id ? "bg-red-200" : "bg-slate-50"}`}>
                {/* Header Section */}
                <div className="flex items-center justify-between p-3 border-gray-200">
                    <div className='flex items-center justify-center gap-1'>
                        <button onClick={async () => {
                            setIsNoteModalOpen(true);
                            await getData(setNoteData, `orders/${order.id}/history`)
                        }}>
                            <PiNote className="text-yellow-500" />
                        </button>
                        <span className="text-sm text-gray-500">{order.orderNumber.substring(4)}</span>
                        <div onClick={() => {
                            setIsPickingModalOpen(true);
                        }}>
                            <IoPrintOutline className='text-blue-600 cursor-pointer' />
                        </div>
                    </div>
                    <div className="flex gap-1 items-center text-gray-600">
                        <span className="text-sm text-gray-800">{order.receiverName}</span>
                    </div>
                </div>

                <div className="bg-white flex flex-col gap-2 p-3 rounded-xl">
                    {/* Product Image Section */}
                    <div>
                        <div className="flex gap-1 overflow-x-auto pb-2">
                            {/* Placeholder images */}
                            {order?.orderItems && order?.orderItems.map((item, index) => {
                                const isNotBodoroj = item.seller.email !== "bodoroj";
                                let vendor = item.seller.email
                                vendor ? vendor = vendor.replace("@bodoroj.com", "") : vendor = ""
                                return (
                                    <div key={index}>
                                        <div className='relative'>
                                            <img
                                                title={item?.title}
                                                src={`${process.env.REACT_APP_CDN_URL}/thumbnail/${item?.productId}/${item?.product?.featuredImage}`}
                                                className={`w-20 h-20 min-h-20 min-w-20 object-cover rounded-lg shadow-sm border-2 ${isNotBodoroj ? "border-red-600" : "border-gray-100"}`}
                                                // onError={(e) => {
                                                //     e.target.onerror = null;
                                                //     e.target.src = "https://placehold.co/100x100/cccccc/333333?text=Error"
                                                // }}
                                                data-tooltip-id={`my-tooltip-${index}-${order.id}`}
                                            />

                                            <span className='absolute -bottom-[5px] -left-[5px] bg-gray-100 border border-gray-200 p-1 flex justify-center items-center w-6 h-6 rounded-lg'>
                                                {item.quantity}
                                            </span>
                                            {
                                                vendor != "bodoroj"
                                                &&
                                                <span className='absolute z-[10] -top-[5px] -left-[5px] bg-gray-100 border border-gray-200 p-1 flex justify-center items-center text-xs rounded-lg'>
                                                    {vendor}
                                                </span>
                                            }
                                        </div>

                                        <ReactTooltip
                                            id={`my-tooltip-${index}-${order.id}`}
                                            place="bottom"
                                            content={item.title + " " + item.sku}
                                        />
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    {
                        true // isShipped
                        &&
                        <div className="flex justify-between items-center gap-2">
                            <div className='flex gap-1'>
                                {
                                    type != "instant" && boxSize.map((size, index) => {
                                        return (
                                            <div
                                                className={`cursor-pointer select-none w-10 h-10 flex justify-center items-center p-2 border-2 ${size.choosen ? "border-blue-500" : "border-gray-200"} rounded-xl`}
                                                onClick={() => { handleChangeBoxSize(index + 1) }}
                                                key={index}
                                            >
                                                {size.id}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className='flex gap-2'>

                                <button className="p-3 bg-slate-50 rounded-xl" onClick={() => { setIsPrintModalOpen(true) }}>
                                    <LiaShippingFastSolid className="text-green-500" />
                                </button>

                                {
                                    type == "nonTehran"
                                    &&
                                    <button className={`p-3  rounded-xl ${parcelData ? "bg-green-100" : "bg-slate-50"}`} onClick={() => { handleEpostParcel() }}>
                                        {
                                            parcelIsLoading
                                                ?
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity="0.25" /><path fill="currentColor" d="M10.72,19.9a8,8,0,0,1-6.5-9.79A7.77,7.77,0,0,1,10.4,4.16a8,8,0,0,1,9.49,6.52A1.54,1.54,0,0,0,21.38,12h.13a1.37,1.37,0,0,0,1.38-1.54,11,11,0,1,0-12.7,12.39A1.54,1.54,0,0,0,12,21.34h0A1.47,1.47,0,0,0,10.72,19.9Z"><animateTransform attributeName="transform" dur="1.125s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12" /></path></svg>
                                                :
                                                <PiBarcode className="text-purple-500" />
                                        }
                                    </button>
                                }
                                {
                                    type == "tehran"
                                    &&
                                    <button className={`p-2 w-12 h-12 rounded-xl ${parcelData ? "bg-green-100" : "bg-blue-400"}`} onClick={() => { handleSubmitAlopeyk() }}>
                                        {
                                            alopeykIsLoading
                                                ?
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity="0.25" /><path fill="currentColor" d="M10.72,19.9a8,8,0,0,1-6.5-9.79A7.77,7.77,0,0,1,10.4,4.16a8,8,0,0,1,9.49,6.52A1.54,1.54,0,0,0,21.38,12h.13a1.37,1.37,0,0,0,1.38-1.54,11,11,0,1,0-12.7,12.39A1.54,1.54,0,0,0,12,21.34h0A1.47,1.47,0,0,0,10.72,19.9Z"><animateTransform attributeName="transform" dur="1.125s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12" /></path></svg>
                                                :
                                                <img src="/assets/img/logos/alopeyk.png" />
                                        }
                                    </button>
                                }
                                {/* <button className="p-3 bg-slate-50 rounded-xl">
                            <TbMapPinCog className="text-slate-500" />
                        </button> */}
                                {/* <button className="p-3 bg-slate-50 rounded-xl">
                            <TbEyeSearch className="text-blue-500" />
                        </button> */}
                            </div>
                        </div>
                    }
                    <div className='flex flex-col gap-2'>
                        <h3 className="text-gray-700 text-sm">زمان سفارش:</h3>
                        <p className="text-gray-600 font-medium">{moment
                            .from(order.createdAt, "en", "YYYY-MM-DD HH:mm:ss")
                            .locale("fa")
                            .format("jYYYY/jMM/jDD HH:mm")}</p>
                    </div>

                    {/* Status Section */}
                    <div className="relative bg-gray-50 rounded-lg p-4 border border-gray-200">
                        <div className="absolute -top-[29px] left-0 flex gap-2">
                            {/* Payment Status */}
                            <div>
                                {/* <p className="text-gray-600 text-sm mb-2">شهر</p> */}
                                <span className="inline-flex items-center px-3 py-1 rounded-t-xl text-sm font-semibold bg-green-100 text-green-800">
                                    {order.city}
                                </span>
                            </div>
                            {/* Delivery Status */}
                            <div>
                                {/* <p className="text-gray-600 text-sm mb-2">استان</p> */}
                                <span className="inline-flex items-center px-3 py-1 rounded-t-xl text-sm font-semibold bg-yellow-100 text-yellow-800">
                                    {order.province}
                                </span>
                            </div>
                        </div>
                        <span className='text-sm select-text'>
                            {order.address}
                        </span>
                    </div>


                    {
                        allSellerItemsHaveInbound
                            ?
                            <div
                                ref={swipeTrackRef}
                                className={`relative w-full h-12 rounded-full shadow-md overflow-hidden
                      ${isShipped ? 'bg-green-500' : 'bg-gradient-to-r from-indigo-600 to-purple-700'}
                      transition-colors duration-300 flex items-center justify-center`}
                            >
                                {/* Swipe fill indicator - fills from left as the ball moves left */}
                                <div
                                    className={`absolute top-0 left-0 h-full bg-green-400 opacity-50
                        ${isShipped ? 'transition-none' : 'transition-all duration-100 ease-out'}`}
                                    style={{ width: `${Math.abs(ballOffset) + (ballRef.current ? ballRef.current.offsetWidth : 0)}px` }}
                                ></div>

                                {/* Button text and icon, positioned above the fill and ball */}
                                <span className="relative select-none z-10 text-white font-bold flex items-center justify-center space-x-2 pointer-events-none">
                                    {isShipped ? (
                                        <>
                                            <span>بسته بندی شده!</span> {/* Shipped! in Persian */}
                                        </>
                                    ) : (
                                        <>
                                            <span className='mr-16'>تغییر به بسته بندی شده</span>
                                        </>
                                    )}
                                </span>

                                {/* Draggable Ball Handle */}
                                {!isShipped && ( // Only show the ball if not yet shipped
                                    <div
                                        ref={ballRef}
                                        className={`absolute top-[4px] !right-[5px] -translate-y-1/2 w-20 h-10 bg-white rounded-full shadow-inner flex items-center justify-center z-20
                          transition-transform duration-100 ease-out
                          ${isSwiping ? 'cursor-grabbing' : 'cursor-grab'}`}
                                        style={{ right: '0px', transform: `translateX(${ballOffset}px)` }} // Positioned from right, then translated
                                        onMouseDown={handleSwipeStart} // Mouse events for desktop
                                        onMouseMove={handleSwipeMove}
                                        onMouseUp={handleSwipeEnd}
                                        onMouseLeave={handleSwipeEnd} // End swipe if mouse leaves the ball area
                                        onTouchStart={handleSwipeStart} // Touch events for mobile
                                        onTouchMove={handleSwipeMove}
                                        onTouchEnd={handleSwipeEnd}
                                    >
                                        {/* Left arrow icon inside the ball */}
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <line x1="19" y1="12" x2="5" y2="12" />
                                            <polyline points="12 19 5 12 12 5" />
                                        </svg>
                                    </div>
                                )}
                            </div>
                            :
                            <div
                                className={`bg-red-600 relative w-full h-12 rounded-full shadow-md overflow-hidden transition-colors duration-300 flex items-center justify-center text-white`}
                            >فروشنده محموله تعریف نکرده است</div>
                    }
                </div>
            </div >


            <Modal isOpen={isPickingModalOpen} toggle={setIsPickingModalOpen} width={1400}>
                <ModalHeader>پرینت جمع آوری</ModalHeader>
                <ModalBody>
                    <div className="p-4 post-label" ref={pickingRef} style={{ direction: "rtl", width: "100%", margin: 0 }}>
                        <div className="w-full flex flex-col gap-1 p-4">
                            <div className="flex justify-between mb-3">
                                <div className="flex gap-1">
                                    <span>سفارش دهنده:</span>
                                    <span>{order?.receiverName}</span>
                                </div>
                                <div className="flex gap-1">
                                    <span>شماره سفارش:</span>
                                    <span>{order?.orderNumber}</span>
                                </div>
                                <div className="flex gap-1">
                                    <span>استان:</span>
                                    <span>{order?.province}</span>
                                </div>
                                <div className="flex gap-1">
                                    <span>شهر:</span>
                                    <span>{order?.city}</span>
                                </div>
                            </div>
                            {
                                order?.orderItems.map(item => {
                                    return (
                                        <div className="p-2 flex flex-row items-center justify-between gap-2 w-full border border-gray-200 rounded-xl">
                                            <div className="flex flex-row gap-3 items-center">
                                                <img className="w-14 border border-gray-100 rounded-xl" src={item?.product?.featuredImage} />
                                                <div className="flex gap-2 items-center">
                                                    <span className="text-sm">
                                                        {item?.title}
                                                    </span>
                                                    <span className="text-xs">
                                                        ({item?.sku})
                                                    </span>
                                                </div>
                                                <div className="flex gap-2 items-center">
                                                    <div className="flex gap-1 items-center dark:bg-gray-700 bg-gray-100 px-2 py-1 rounded-lg text-xs">
                                                        <span>{item.quantity}</span>
                                                        <span>عدد</span>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="flex items-center gap-1 mx-2">

                                                <span className="font-semibold">
                                                    {numberWithCommas((item.salePrice ?? item.price) * item.quantity)}
                                                </span>
                                                <span className="text-xs">تومان</span>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <TwinButton
                        acceptTitle="چاپ لیبل"
                        acceptHandle={() => { reactToPrintFn2() }}
                        rejectHandle={() => { setIsPickingModalOpen(false) }}
                        rejectTitle="بستن"
                        isCompact={true}
                    />
                </ModalFooter>
            </Modal>



            <Modal isOpen={false} toggle={setIsPrintModalOpen} width={1400}>
                <ModalHeader>پرینت لیبل پستی</ModalHeader>
                <ModalBody>
                    <div className="p-4 post-label" ref={receiptRef} style={{ direction: "rtl", width: "100%", margin: 0 }}>
                        <div className="template-1 container">
                            <div className="flex justify-center items-center border border-gray-500 bg-white">
                                <div className="flex gap-2 flex-col p-4 flex-1">
                                    <div>
                                        <span className="font-bold">گیرنده:</span> {order?.state}، {order?.city}، {order?.address}
                                    </div>
                                    <div>
                                        <span className="font-bold">نام کامل:</span> {order?.receiverName}
                                    </div>
                                    <div>
                                        <span className="font-bold">کد پستی:</span> {order?.postalCode}
                                    </div>
                                    <div>
                                        <span className="font-bold">تلفن:</span> {order?.receiverPhone}
                                    </div>
                                    <div>
                                        <span className="font-bold">تاریخ سفارش:</span>
                                        {order?.createdAt
                                            ? moment
                                                .from(order?.createdAt, "en", "YYYY-MM-DD HH:mm:ss")
                                                .locale("fa")
                                                .format("jYYYY/jMM/jDD HH:mm")
                                            : "---"}
                                    </div>
                                    {
                                        order?.customer_note
                                        &&
                                        <div>
                                            <span className="font-bold">یادداشت مشتری:</span> {order?.customer_note}
                                        </div>
                                    }
                                </div>
                                <div className="flex gap-2 flex-col p-4 flex-1 border-r border-gray-500">
                                    <div>
                                        <span className="font-bold">فرستنده: بدورژ</span>
                                    </div>
                                    <div>
                                        <span className="font-bold">آدرس:</span> تهران، اشرفی اصفهانی شمال، بالاتر از میدان پونک، خیابان رمضانی، پلاک 26 واحد 7
                                    </div>
                                    <div>
                                        <span className="font-bold">کد پستی:</span> 1469653148
                                    </div>
                                    <div>
                                        <span className="font-bold">تلفن:</span> ۰۲۱۹۱۰۰۷۲۷۹
                                    </div>
                                    <div>
                                        <span className="font-bold">ایمیل:</span> info@bodoroj.com
                                    </div>
                                    <div>
                                        <span className="font-bold">وبسایت:</span> https://bodoroj.com
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <TwinButton
                        acceptTitle="چاپ لیبل"
                        acceptHandle={() => { reactToPrintFn() }}
                        rejectHandle={() => { setIsPrintModalOpen(false) }}
                        rejectTitle="بستن"
                        isCompact={true}
                    />
                </ModalFooter>
            </Modal>

            <Modal isOpen={isNoteModalOpen} toggle={setIsNoteModalOpen}>
                <ModalHeader>
                    یادداشت های سیستمی سفارش
                </ModalHeader>
                <ModalBody>
                    {
                        noteData
                            ?
                            <div className="grid grid-cols-2 gap-4 p-4">
                                {noteData.map((note, index) => {
                                    return (
                                        <div class="w-full bg-yellow-200 shadow-lg rounded-lg p-4 font-handwriting text-gray-800 relative transform rotate-1">
                                            <h6 class="font-bold mb-2">یادداشت - {note.user ? note?.user?.firstName + " " + note?.user?.lastName : "سیستمی"} - {moment
                                                .from(note?.createdAt, "en", "YYYY-MM-DD HH:mm:ss")
                                                .locale("fa")
                                                .format("jYYYY/jMM/jDD HH:mm")}</h6>
                                            <p class="text-sm leading-relaxed text-right">
                                                <div dangerouslySetInnerHTML={{ __html: note?.note }} />
                                            </p>
                                            <div class="flex justify-center items-center w-8 h-8 bg-yellow-300 rounded-full absolute -top-2 -right-2 border-2 border-yellow-400 shadow-md">{index + 1}</div>
                                        </div>
                                    )

                                })}
                            </div>
                            :
                            <div className="w-full flex justify-center items-center">
                                <Spinner />
                            </div>
                    }


                </ModalBody>
                <ModalFooter>
                    <TwinButton
                        rejectHandle={() => { setIsNoteModalOpen(false) }}
                        isCompact
                        rejectTitle='بستن'
                        acceptTitle={false}
                    />
                </ModalFooter>
            </Modal>

            <Modal isOpen={isEpostModalOpen} toggle={setIsEpostModalOpen}>
                <ModalHeader>رسید پستی</ModalHeader>
                <ModalBody>
                    <div ref={parcelRef} style={{ direction: "rtl" }}>
                        <ParcelUI orderData={order} parcelData={parcelData} />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <TwinButton
                        acceptTitle="پرینت رسید پستی"
                        acceptHandle={() => { reactToPrintParcelFn() }}
                        isCompact={true}
                        rejectTitle="بستن"
                        rejectHandle={() => {
                            setIsEpostModalOpen(false);
                        }}
                    />
                </ModalFooter>
            </Modal>

        </>
    )
}
